import React from 'react';

import { useComponentSearchData } from 'components/component-overview/hooks/use-component-search-data';
import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { NoExactMatchesAlert } from 'components/search/components/NoExactMatchesAlert';

export const NoExactProductMatches = () => {
    const { exact, isLoading, docs } = useComponentSearchData();
    const { search } = useComponentSearchFilters();

    if (exact || isLoading || !search || docs.length === 0) {
        return null;
    }

    return <NoExactMatchesAlert query={search} />;
};
